import type { SiteConfig } from "./types";
import type { HomePageContent } from "./types";
import { siteConfigSchema } from "./schemas";
import { homePageContentSchema } from "./schemas";

/**
 * Parse and validate a SiteConfig from unknown input.
 * Throws a ZodError if validation fails.
 */
export function parseSiteConfig(json: unknown): SiteConfig {
  return siteConfigSchema.parse(json);
}

/**
 * Safely parse a SiteConfig, returning null on failure.
 */
export function safeParseSiteConfig(json: unknown): SiteConfig | null {
  const result = siteConfigSchema.safeParse(json);
  return result.success ? result.data : null;
}

/**
 * Parse and validate HomePageContent from unknown input.
 * Throws a ZodError if validation fails.
 */
export function parseHomePageContent(json: unknown): HomePageContent {
  return homePageContentSchema.parse(json);
}

/**
 * Safely parse HomePageContent, returning null on failure.
 */
export function safeParseHomePageContent(json: unknown): HomePageContent | null {
  const result = homePageContentSchema.safeParse(json);
  return result.success ? result.data : null;
}
